import { types } from 'mobx-state-tree';

export const FilesCount = types
  .model({
    wpfilesCount: types.maybeNull(types.number),
    assetfilescount: types.maybeNull(types.number),
    previousreportfilescount: types.maybeNull(types.number),
    signandstampfilescount: types.maybeNull(types.number),
    signandstampUserLevelfilescount: types.maybeNull(types.number),
  })
  .views(self => ({
    get getWpFilesCount() {
      return self.wpfilesCount;
    },
    get getAssetFilesCount() {
      return self.assetfilescount;
    },
    get getPreviousReportFilesCount() {
      return self.previousreportfilescount;
    },
    get getSignAndStampFilesCount() {
      return self.signandstampfilescount;
    },
    get getSignAndStampUserLevelFilesCount() {
      return self.signandstampUserLevelfilescount;
    },
  }))
  .actions(self => ({
    setWpFileCount: (count: number) => {
      self.wpfilesCount = count;
    },
    setAssetFilesCount: (count: number) => {
      self.assetfilescount = count;
    },
    setPreviousReportFilesCount: (count: number) => {
      self.previousreportfilescount = count;
    },
    setSignAndStampFilesCount: (count: number) => {
      self.signandstampfilescount = count;
    },
    setSignAndStampUserLevelFilesCount: (count: number) => {
      self.signandstampUserLevelfilescount = count;
    },
    decreaseWpFileCount: () => {
      if (self.wpfilesCount) {
        self.wpfilesCount = self.wpfilesCount - 1;
      }
    },
    decreaseAssetFilesCount: () => {
      if (self.assetfilescount) {
        self.assetfilescount = self.assetfilescount - 1;
      }
    },
    decreasePreviousReportFilesCount: () => {
      if (self.previousreportfilescount) {
        self.previousreportfilescount = self.previousreportfilescount - 1;
      }
    },
    decreaseSignAndStampFilesCount: () => {
      if (self.signandstampfilescount) {
        self.signandstampfilescount = self.signandstampfilescount - 1;
      }
    },
    decreaseSignAndStampUserLevelFilesCount: () => {
      if (self.signandstampUserLevelfilescount) {
        self.signandstampUserLevelfilescount = self.signandstampUserLevelfilescount - 1;
      }
    },
  }));

export default FilesCount;
